import {Component, EventEmitter, Output} from '@angular/core';
import {SSOProvider} from '@app/models/auth/sso-provider.enum';
import {ButtonType} from '@app/shared/components/inputs/button/button.component';

@Component({
    selector: 'app-login-sso-google-component',
    templateUrl: './login-sso-google.component.html',
    styleUrls: ['./login-sso-google.component.scss'],
})
export class LoginSSOGoogleComponent {
    public readonly eButtonType = ButtonType;

    @Output() public readonly buttonClick = new EventEmitter<SSOProvider.GOOGLE>();

    login(): void {
        this.buttonClick.emit(SSOProvider.GOOGLE);
    }

}